<template>
    <card xs-tile sm-tile class="flex-grow-1">
        <card-text fill>
            <server-content :action="$api('events.gtc', eventStore.event.id)"
							as-guest
                            :data="{ts: eventStore.event.cache_buster}"
                            :missing="$t('missing.event.gtc')"
                            access="gtc" skeleton="paragraph@30"/>
        </card-text>
    </card>
</template>

<script setup lang="ts">
import {EventPageType} from "@spoferan/spoferan-ts-core";
import {useEventStore} from "../../../store/event";

const eventStore = useEventStore();
const {t} = useI18n();
const {$web} = useNuxtApp();
const route = useRoute();

// Make sure the page is activated
if (!eventStore.hasActivePage(EventPageType.Gtc)) {
	await navigateTo($web('events.show', route.params.event));
}

useMeta({
	title: eventStore.buildPageTitle(t('view.events.gtc.index.title', {event: eventStore.event.display_name})),
	description: t('view.events.gtc.index.description', {event: eventStore.event.display_name})
})

</script>

